module.exports = __webpack_public_path__ + "static/media/StrengthMagazineStyleGuide.cac51af7.jpg";